var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0 {\n        fill: none;\n      }\n    ")),React.createElement("path",{"className":"st0","d":"M0,0h24v24H0V0Z","key":1}),React.createElement("path",{"d":"M13,20V7.8l5.6,5.6,1.4-1.4L12,4,4,12l1.4,1.4,5.6-5.6v12.2h2Z","key":2})]);
}

ArrowUp.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 24 24"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
